/*
 * Public API Surface of kraken-theme
 */

export * from './lib/kraken-theme.service';
export * from './lib/kraken-theme.component';
export * from './lib/kraken-theme.module';
